export default function CtaSection() {
  return (
    <section className="relative py-24 md:py-32 px-4 md:px-6 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Wide%20horizontal%20composition%20of%20carefully%20styled%20fashion%20accessories%20and%20leather%20goods%20arranged%20in%20sweeping%20diagonal%20line%20across%20warm%20sandstone%20surface%2C%20dramatic%20side%20lighting%20from%20large%20window%20creating%20long%20artistic%20shadows%2C%20elevated%20lifestyle%20catalog%20photography%2C%20rich%20caramel%20cognac%20and%20cream%20palette%2C%20sophisticated%20luxury%20retail%20atmosphere&width=1920&height=600&seq=cta-banner-v2-2026&orientation=landscape)`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/50" />

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-10">
          <div className="md:max-w-xl">
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight">
              Ready To Explore?
            </h2>
          </div>
          <div className="md:max-w-md">
            <p className="text-white/80 text-base md:text-lg leading-relaxed mb-6">
              Access the complete Hipobuy Spreadsheet resource and start discovering products across all categories today.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-6 py-3.5 bg-accent-500 text-background-50 rounded-full text-base font-semibold whitespace-nowrap hover:bg-accent-600 transition-all"
            >
              Buy It Now
              <span className="w-6 h-6 flex items-center justify-center rounded-full bg-background-50/20">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}